/**
 * Reglas del editor de flujos de aprobación (OT-0055): pseudo-roles y lo
 * que rechazaría el backend (`WorkflowDefinition`). Qué roles del catálogo
 * puede pedir una etapa lo decide `citableTemplates` (lib/methodologyScope).
 */

import type { ApprovalWorkflowDefinition } from '../../../api/templates'
import type { ClientValidationIssue } from './state'
import { DEFAULT_LOCALE, pickLocalized, SUPPORTED_LOCALES } from '../../../i18n/config'

/** Espejo de `WorkflowDefinition.stages` y `required_roles` (`max_length=10`). */
export const MAX_STAGES = 10
export const MAX_ROLES = 10
/** Pseudo-roles que el backend resuelve en el proyecto (no están en el
 * catálogo): `PSEUDO_ROLE_KEYS` de `methodology_completeness.py`. */
export const PSEUDO_ROLE_KEYS = ['rol-analyst-author', 'rol-project-leader'] as const

export function isPseudoRole(key: string): boolean {
  return (PSEUDO_ROLE_KEYS as readonly string[]).includes(key)
}

/** Lo que el backend rechazaría (`WorkflowDefinition`): sin etapas, una
 * etapa sin nombre en ningún idioma, sin roles, o el flujo sin nombre en un
 * idioma que declara. */
export function findWorkflowIssues(definition: ApprovalWorkflowDefinition): ClientValidationIssue[] {
  const issues: ClientValidationIssue[] = []
  for (const loc of SUPPORTED_LOCALES) {
    const block = definition.i18n[loc]
    if (block && !block.name.trim()) {
      issues.push({ code: 'missing_name', path: `i18n.${loc}.name`, params: { locale: loc } })
    }
  }
  if (definition.stages.length === 0) {
    issues.push({ code: 'no_stages', path: 'stages', params: {} })
  }
  for (const stage of definition.stages) {
    const order = String(stage.order)
    // Basta un idioma: quien lo muestra en otro cae al que exista.
    if (!pickLocalized(stage.name, DEFAULT_LOCALE)) {
      issues.push({ code: 'missing_stage_name', path: `stages[${order}].name`, params: { order } })
    }
    if (stage.required_roles.length === 0) {
      issues.push({ code: 'missing_stage_roles', path: `stages[${order}]`, params: { order } })
    }
  }
  return issues
}
